/* eslint-disable no-unused-expressions */
import {Tour} from "../Tour";
import { i18n } from 'src/boot/i18n';

const listenButtonStep = {
  title: i18n.t('onboardingPlayerData.PlayerTour.listenButton.title'),
  intro: i18n.t('onboardingPlayerData.PlayerTour.listenButton.intro'),
  element: '.player-tour__listen-button',
}

const tours = [
  {
    name: "PlayerTour",
    steps: [
      listenButtonStep,
      // {
      //   title: "À vous de jouer !",
      //   intro: "Cliquez sur ce bouton pour lancer le morceau et le jouer en même temps sur votre piano. \n Un décompte vous laissera le temps de placer votre main.",
      //   element: ".player-tour__play",
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-keep-basic');
      //     const menuContent: HTMLElement = document.querySelector('.player-freemode-tour-mobile__visibility-and-sound') as HTMLElement;
      //     if (menuContent) {
      //       const menuBtn: HTMLElement = document.querySelector('.player-freemode-tour-mobile__dots-controls') as HTMLElement;
      //       menuBtn.click();
      //     }
      //   }
      // }
    ]
  },

  {
    name: "PlayerFreeModeTour",
    steps: [
      /* Mobile */
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: 'En mobile, ce bouton permet d\'accéder aux outils pour travailler à votre rythme.',
      //   element: '.player-freemode-tour-mobile__dots-controls',
      //   isOnlyMobile: true,
      //   isOnlyDesktop: false,
      // },

      // Disable it for now since q-menu is hidden when clicked outside (making it disapear each time you try to got o the next step)
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "Ici vous pourrez régler et désactiver les sons et l'affichage des mains, du métronome et des paroles.",
      //   beforeChange: (arr: any[], index: any) => {
      //     arr[index].element = document.querySelector('.player-freemode-tour-mobile__visibility-and-sound')
      //   },
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.remove('introjs-keep-basic');
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-mobile-top');
      //   },
      //   isOnlyMobile: true,
      // },
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "En cliquant ici vous pourrez activer une boucle de la partie sur laquelle vous vous trouvez.",
      //   beforeChange: (arr: any[], index: any) => {
      //     arr[index].element = document.querySelector('.player-freemode-tour-mobile__loop')
      //   },
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-mobile-top');
      //   },
      //   isOnlyMobile: true,
      // },
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "Ici vous gérez la vitesse de lecture, bouton très important pour travailler le morceau en baissant la vitesse !",
      //   beforeChange: (arr: any[], index: any) => {
      //     arr[index].element = document.querySelector('.player-freemode-tour-mobile__speed')
      //   },
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-mobile-top');
      //   },
      //   onStepLeave: () => {
      //     const menuContent: HTMLElement = document.querySelector('.player-freemode-tour-mobile__visibility-and-sound') as HTMLElement;
      //     if (menuContent) {
      //       const menuBtn: HTMLElement = document.querySelector('.player-freemode-tour-mobile__dots-controls') as HTMLElement;
      //       menuBtn.click();
      //     }
      //   },
      //   isOnlyMobile: true,
      // },
      /* Desktop */
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "Ici vous pourrez régler et désactiver les sons et l'affichage des mains, du métronome et des paroles.",
      //   element: ".player-freemode-tour-desktop__visibility-and-sound",
      //   isOnlyDesktop: true,
      // },
      {
        title: i18n.t('onboardingPlayerData.PlayerFreeModeTour.loop.title'),
        intro: i18n.t('onboardingPlayerData.PlayerFreeModeTour.loop.intro'),
        element: ".player-freemode-tour-desktop__loop",
        isOnlyDesktop: true,
      },
      {
        title: i18n.t('onboardingPlayerData.PlayerFreeModeTour.speed.title'),
        intro: i18n.t('onboardingPlayerData.PlayerFreeModeTour.speed.intro'),
        element: ".player-freemode-tour-desktop__speed",
        isOnlyDesktop: true,
      },
      /* Both */
      {
        title: i18n.t('onboardingPlayerData.PlayerFreeModeTour.help.title'),
        intro: i18n.t('onboardingPlayerData.PlayerFreeModeTour.help.intro'),
        element: ".player-freemode-tour__help",
      }
    ]
  } as Tour,

  {
    name: "PlayerClassTour",
    steps: [
      {
        title: i18n.t('onboardingPlayerData.PlayerClassTour.step1.title'),
        intro: i18n.t('onboardingPlayerData.PlayerClassTour.step1.intro'),
      },
      {
        title: i18n.t('onboardingPlayerData.PlayerClassTour.step2.title'),
        intro: i18n.t('onboardingPlayerData.PlayerClassTour.step2.intro'),
        element: ".player-class-tour__section",
      },
      {
        title: i18n.t('onboardingPlayerData.PlayerClassTour.step3.title'),
        intro: i18n.t('onboardingPlayerData.PlayerClassTour.step3.intro'),
        element: ".player-class-tour__part"
      },
      {
        title: i18n.t('onboardingPlayerData.PlayerClassTour.step4.title'),
        intro: i18n.t('onboardingPlayerData.PlayerClassTour.step4.intro'),
        element: ".player-class-tour__all-parts"
      },
      // Disable Sing Step since it is not present in most of our songs
      // {
      //   title: "Mode cours",
      //   intro: "...et à placer le chant dessus.",
      //   element: ".player-class-tour__chant"
      // },
    ]
  },

  {
    name: "PlayerScoreEvolutionTour",
    steps: [
      {
        title: i18n.t('onboardingPlayerData.PlayerScoreEvolutionTour.step1.title'),
        intro: i18n.t('onboardingPlayerData.PlayerScoreEvolutionTour.step1.intro'),
        element: ".tour-score-evolution",
      },
      {
        title: i18n.t('onboardingPlayerData.PlayerScoreEvolutionTour.step2.title'),
        intro: i18n.t('onboardingPlayerData.PlayerScoreEvolutionTour.step2.intro'),
        element: ".tour-score-evolution"
      },
    ]
  },

  {
    name: "ShowParameterTour_tempo",
    steps: [
      {
        title: i18n.t('onboardingPlayerData.ShowParameterTour_tempo.step1.title'),
        intro: i18n.t('onboardingPlayerData.ShowParameterTour_tempo.step1.intro'),
        element: ".player-freemode-tour-desktop__speed",
      },
    ]
  },

  {
    name: "ShowParameterTour_sound",
    steps: [
      {
        title: i18n.t('onboardingPlayerData.ShowParameterTour_sound.step1.title'),
        intro: i18n.t('onboardingPlayerData.ShowParameterTour_sound.step1.intro'),
        element: ".player-tour__volume",
      },
    ]
  },

  {
    name: "ShowParameterTour_MobileDisplayMenu",
    steps: [
      {
        title: i18n.t('onboardingPlayerData.ShowParameterTour_MobileDisplayMenu.step1.title'),
        intro: i18n.t('onboardingPlayerData.ShowParameterTour_MobileDisplayMenu.step1.intro'),
        element: ".player-tour__displayMenu",
      },
    ]
  },

  {
    name: "ShowParameterTour_displayFingerOrNotes",
    steps: [
      {
        title: i18n.t('onboardingPlayerData.ShowParameterTour_displayFingerOrNotes.step1.title'),
        intro: i18n.t('onboardingPlayerData.ShowParameterTour_displayFingerOrNotes.step1.intro'),
        element: ".player-tour__displayFingerOrNotes",
      },
      {
        title: i18n.t('onboardingPlayerData.ShowParameterTour_listenModeButton.step1.title'),
        intro: i18n.t('onboardingPlayerData.ShowParameterTour_listenModeButton.step1.intro'),
        element: ".player-tour__listen-button",
      }
    ]
  },
  {
    name: "ShowParameterTour_listenModeButton",
    steps: [listenButtonStep]
  },

  {
    name: "ShowParameterTour_sheetMusicMode",
    steps: [
      {
        title: i18n.t('onboardingPlayerData.ShowParameterTour_sheetMusicMode.step1.title'),
        intro: i18n.t('onboardingPlayerData.ShowParameterTour_sheetMusicMode.step1.intro'),
        element: ".player-tour__pianoRollSheetMusic",
      },
    ]
  },

  /* Mobile */
  // {
  //   title: "Travailler à votre rythme en autonomie",
  //   intro: 'En mobile, ce bouton permet d\'accéder aux outils pour travailler à votre rythme.',
  //   element: '.player-freemode-tour-mobile__dots-controls',
  //   onStepEnter: () => {
  //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-keep-basic');
  //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.remove('introjs-mobile-top');
  //   },
  //   onStepLeave: () => {},
  //   beforeChange: () => {},
  //   isOnlyMobile: true,
  //   isOnlyDesktop: false,
  // },
  /* Desktop */
  // {
  //   title: "Travailler à votre rythme en autonomie",
  //   intro: "Ici vous pourrez régler et désactiver les sons et l'affichage des mains, du métronome et des paroles.",
  //   element: ".player-freemode-tour-desktop__visibility-and-sound",
  //   isOnlyDesktop: true,
  // },
  // {
  //   title: "Travailler à votre rythme en autonomie",
  //   intro: "En cliquant ici vous pourrez activer une boucle de la partie sur laquelle vous vous trouvez.",
  //   element: ".player-freemode-tour-desktop__loop",
  //   isOnlyDesktop: true,
  // },

] as Tour[];

export default {tours};
